import './ImpersonatorNotice.scss';

import { adminActions } from '@sonar-software/sonar-admin';
import { createAsyncSelectors } from '@lib/selectors';
import { useNavigate } from 'react-router';

import { Alert, Button, Flex } from 'antd';
import { BASE_ROUTES, COPY_SPECIFIC, QUERY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useEffect, useState } from 'react';
import { useAction, useAuthToken, useSonarSelector } from '../hooks';

const impersonateStopSelectors = createAsyncSelectors((state) => state.admin.authentication.impersonateStop.get);

export const ImpersonatorNotice: React.FC = () => {
	const [ search, setSearch ] = useState<string>('');
	const navigate = useNavigate();
	const { isImpersonator, impersonatorShard } = useAuthToken();
	const impersonateStopToken = useSonarSelector(impersonateStopSelectors.data);
	const getImpersonateStop = useAction(adminActions.requestGetAdminAuthenticationImpersonateStop);

	const handleOnExit = useCallback(() => {
		getImpersonateStop({ shardName: impersonatorShard });
	}, [ getImpersonateStop, impersonatorShard ]);

	const handleOnSwitch = useCallback(() => {
		setSearch(`?${QUERY.TARGET_ROUTE}=${BASE_ROUTES.ADMIN}`);
		handleOnExit();
	}, [ handleOnExit ]);

	useEffect(() => {
		if (impersonateStopToken) {
			navigate({
				pathname: `/token/${impersonateStopToken.token}`,
				search
			},
			{ replace: true });
		}
	}, [ impersonateStopToken, navigate, search ]);

	if (!isImpersonator) {
		return null;
	}

	return (
		<Alert
			action={
				<Flex gap={ 4 }>
					<Button
						danger
						onClick={ handleOnSwitch }
						size='small'>
						{ COPY_SPECIFIC.SWITCH }
					</Button>
					<Button
						danger
						onClick={ handleOnExit }
						size='small'>
						{ COPY_SPECIFIC.EXIT }
					</Button>
				</Flex>
			}
			className='impersonator-notice'
			message={ COPY_SPECIFIC.ADMIN_IMPERSONATOR_MODE }
			showIcon
			type='error' />
	);
};
